module.exports = "<ul><li><a routerLinkActive=\"selected\" routerLink=\"list\">Funnels <span class=\"fad fa-book-spells\"></span></a></li></ul>"